import { render, staticRenderFns } from "./ModalChooseItemType.vue?vue&type=template&id=3fbb8c9c&scoped=true"
import script from "./ModalChooseItemType.vue?vue&type=script&lang=js"
export * from "./ModalChooseItemType.vue?vue&type=script&lang=js"
import style0 from "./ModalChooseItemType.vue?vue&type=style&index=0&id=3fbb8c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbb8c9c",
  null
  
)

export default component.exports